import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../Vas';
import '../css/Login.css';
import { ExtendedButton,TextField,LinkButton,MessageBox,Loading } from "component-lib";
import { AccountsModel, RequestAjaxClass } from 'models-lib';

class Login extends Component {

    constructor(props){
        super(props);
        this.state = {};
        localStorage.removeItem("anonymous_token");
        localStorage.removeItem('vas_token');
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.AccountsModel = new AccountsModel([this],null,this.Request);
    }

    componentDidMount()
    {
        let me = this;
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setErrorHandler((data)=>{
          ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
          $("#username").val('');
          $("#password").val('');
          ReactDOM.render(<MessageBox 
            AppURL={me.ApplicationUrl} 
            Title={Vas.Resources.Titles["Note"]} 
            Message={data.responseJSON.Description} />,document.getElementById("popupContainer"));
        }); 
        $("#username").focus();
        
        $(document).keyup(function(e) {
            switch (e.which){
                case 13:{//Enter
                    me.login();
                   break;     
                }
                default:break;
            }
        });
    }

    login(){
      if ($('#username')){
        if ($('#username').val() !== null && $('#username').val() !== undefined && $('#password').val() !== null && $('#password').val() !== undefined){
          if (($('#username').val().length !== 0)&&($('#password').val().length !== 0)){
            this.AccountsModel.Login($("#username").val(),$("#password").val());
            ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
          } else {
             /* ReactDOM.render(<MessageBox
                Message={Vas.Resources.Labels["NotAllFields"]}
                Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));*/
          }
        }
      }
    }

    PasswordForgotten(){
      Vas.GetView("ResetPassword",null,false);
        //ReactDOM.render(<ResetPassword />,document.getElementById('popupContainer'));
    }

    Update(observer){
      if(observer === "Login"){
        this.Request.setAuth(true);
        this.AccountsModel.Own();
      }
      else if(observer === "AccountsOwn"){
        localStorage.setItem("vas_customerId", this.AccountsModel.Customer.Id);
        window.location = "/home";
        ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
      }
    }

    render()
    {
        if (localStorage.getItem("ExpiredToken") === "expiredToken"){
            
            localStorage.removeItem("ExpiredToken");
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl}  
              Title={Vas.Resources.Titles["Error"]} 
              Message={Vas.Resources.Labels["ExpiredToken"]} /> 
                , document.getElementById('messageContainer'));
        }

        return (
          <div >
            <div className="LoginContainer" >
              <div 
                className={"form"} 
                style={{ textAlign:'left' }}>
                <h2>{Vas.Resources.Menus["Login"]}</h2><br />
                <table>
                  <tbody>
                    <tr>
                      <td colSpan={2}><b>{Vas.Resources.Labels["Username"]}</b>: {Vas.Resources.Labels["EmailRegistration"]}<br /><br /></td>
                    </tr>
                    <tr>
                      <td colSpan={2}><TextField 
                        AppURL={Vas.ApplicationUrl} 
                        Width={310} 
                        Editable={true} 
                        name='username' 
                        Id="username" 
                        Label={Vas.Resources.Labels["Username"]} 
                        Tooltip={Vas.Resources.Tooltips["Username"]}  
                        onKeyPress={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    $("#password").focus();
                                                }
                                            }} />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}><TextField 
                        AppURL={Vas.ApplicationUrl} 
                        Width={310} 
                        Type={"password"} 
                        Editable={true} 
                        name='password' 
                        Id="password" 
                        Label={Vas.Resources.Labels["Password"]} 
                        Tooltip={Vas.Resources.Tooltips["Pwd"]} 
                        onKeyPress={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    this.login();
                                                }
                                            }} />
                        <br />
                      </td>
                    </tr>
                    <tr>
                      <td><ExtendedButton 
                        Usable={true}
                        Width={150} 
                        className={"loginButton"}  
                        Text={Vas.Resources.Menus["Login"]}  
                        OnClick={()=>{ this.login(); }} />
                      </td>
                      <td><ExtendedButton 
                        Usable={true} 
                        Width={150} 
                        className={"loginButton"}  
                        Text={Vas.Resources.Labels["Cancel"]} 
                        OnClick={()=> { Vas.GetView('Order');}} />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <LinkButton 
                          Text={Vas.Resources.Labels["PasswordForgotten"]} 
                          Id={"PasswordForgotten"} 
                          OnClick={()=>{this.PasswordForgotten();}} />
                      </td>
                    </tr>
                  </tbody>
                </table>    
              </div>
            </div>
          </div>
        );
    }
}
export default Login;
